import { useTranslation } from "react-i18next";
import { ConfirmModal, Spinner } from "src/components";

interface propState {
  isOpen: boolean;
  current: number;
  total: number;
}

function InviteLoadingModal(props: propState) {
  const { t } = useTranslation(["user"]);

  return (
    <ConfirmModal isOpen={props.isOpen}>
      <div>
        <section className="contents-indicator">
          <Spinner size="page" />
        </section>
        <p className="font18 font-weight-600 mb20">{t("inviteUser.sendingMessage")}</p>
        <p>{`${props.current} / ${props.total}`}</p>
      </div>
    </ConfirmModal>
  );
}

export default InviteLoadingModal;
